import { setPds } from './pds/actions';
import { setGraphTicks } from './graphTicks/actions';
import { setCutoffs } from './cutoffs/actions';
import { setBinomialAlpha } from './binomialAlpha/action';
import { getTailType } from './chart/selectors';
import { setTailType } from './chart/actions';
import { CHART_TAIL_TYPES } from './chart/enums';

import getDistributionFunctionsByType from 'calculators/distributions';
import { setLeftCutoff, setRightCutoff, setBLeftCutoff, setBRightCutoff, setLeftZScore, setRightZScore } from 'store/form/distributions/actions';
import { getAlpha } from 'store/form/distributions/selectors';

export const generateDistributionData = distributionFormValues => (dispatch, getState) => {
  const { type } = distributionFormValues;
  const state = getState();
  let alpha = getAlpha(state);
  let tailType = getTailType(state);
  const fns = getDistributionFunctionsByType(type);
  let graphTicks = null;
  let leftZScore = -1;
  let rightZScore = 1;
  const pds = fns.getPds(distributionFormValues);
  const isNormalDistribution = type === 'normal';
  const isBinomialDistribution = type === 'binomial';

  if (tailType === CHART_TAIL_TYPES.EQUAL && !isBinomialDistribution) {
    tailType = CHART_TAIL_TYPES.LEFT;
  }

  // reverse alpha value if tail is center
  const preliminaryAlpha =
    tailType === CHART_TAIL_TYPES.CENTER
      ? 1 - alpha
      : alpha;

  const recalculatedAlpha =
    tailType === CHART_TAIL_TYPES.BOTH || tailType === CHART_TAIL_TYPES.CENTER
      ? preliminaryAlpha / 2
      : preliminaryAlpha;

  const cutoffs = fns.getCutoffsByAlpha(distributionFormValues, recalculatedAlpha, tailType);

  if (isNormalDistribution) {
    graphTicks = fns.getGraphTicks(distributionFormValues);
    leftZScore = fns.getZScoreByCutoffValue(distributionFormValues, cutoffs.left.x);
    rightZScore = fns.getZScoreByCutoffValue(distributionFormValues, cutoffs.right.x);
  }

  if (isBinomialDistribution) {
    alpha = fns.getAlphaByCutoffsAndTailType(distributionFormValues, cutoffs.left.x, cutoffs.right.x, tailType);
    dispatch([
      setPds(pds),
      setCutoffs(cutoffs),
      setBinomialAlpha(alpha),
      setBLeftCutoff(cutoffs.left.x),
      setBRightCutoff(cutoffs.right.x)
    ]);
  } else {
    dispatch([
      setPds(pds),
      setCutoffs(cutoffs),
      setTailType(tailType),
      setGraphTicks(graphTicks),
      setLeftCutoff(cutoffs.left.x),
      setRightCutoff(cutoffs.right.x),
      setLeftZScore(leftZScore),
      setRightZScore(rightZScore)
    ]);
  }
};
